// Generated by ReScript, PLEASE EDIT WITH CARE


var ga_title_home = "Home Page";

var ga_path_home = "/";

var ga_title_enterprise_faqs = "Enterprise FAQs";

var ga_path_enterprise_faqs = "/enterprise-faq";

var ga_title_seo_pillar = "Services Pillar";

var ga_path_seo_pillar = "/services";

var ga_title_seo_keyword_prefix = "Services Keyword - ";

var ga_path_seo_keyword_prefix = "/services/";

var ga_title_privacy_policy = "Privacy Policy";

var ga_path_privacy_policy = "/privacy-policy";

var ga_title_privacy_policy_v1 = "Privacy Policy";

var ga_path_privacy_policy_v1 = "/privacy-policy-v1";

var ga_title_privacy_policy_v2 = "Privacy Policy V2";

var ga_path_privacy_policy_v2 = "/privacy-policy-v2";

var ga_title_spot_faq = "Spot FAQs";

var ga_path_spot_faq = "/spot-faq";

var ga_title_porter_wallet_faq = "Porter Wallet FAQs";

var ga_path_porter_wallet_faq = "/porter-wallet-faq";

var ga_title_insurance_faq = "Insurance FAQs";

var ga_path_insurance_faq = "/insurance-faq";

var ga_title_tos_partners = "Terms of Service - Partners";

var ga_path_tos_partners = "/terms-of-service/partners";

var ga_title_referral_tnc = "Terms and Conditions - Refferal";

var ga_path_referral_tnc = "/referral-tnc";

var ga_title_courier_tnc = "Terms and Conditions - Courier";

var ga_path_courier_tnc = "/courier/tnc";

var ga_title_terms_of_service = "Terms of Service";

var ga_path_terms_of_service = "/terms-of-service";

var ga_title_support = "Support";

var ga_path_support = "/support";

var ga_title_about_us = "About Us";

var ga_path_about_us = "/about-us";

var ga_title_enterprise_lp = "Enterprise Lead Page";

var ga_path_enterprise_lp = "/enteprise-lead-page";

var ga_title_offers = "Offers";

var ga_path_offers = "/offers";

var ga_title_careers = "Careers";

var ga_path_careers = "/careers";

var ga_path_city_page_prefix = "/trucks/";

var ga_title_city_page_prefix = "City Page - ";

var ga_path_trucks_prefix = "/trucks/";

var ga_title_trucks_prefix = "City Page - ";

var ga_title_fare_estimate_result = "Fare Estimate Result";

var ga_path_fare_estimate_result = "/fare_estimate_mob";

var ga_title_partners = "Partners";

var ga_path_partners = "/partners";

var ga_path_enterprise = "/enterprise";

var ga_title_enterprise = "enterprise";

var ga_path_api_integrations = "/api-integrations";

var ga_title_api_integrations = "API Integrations";

var ga_title_404 = "404 Page";

var ga_title_bike_parcel_keyword_prefix = "Bike Parcel - ";

var ga_path_bike_parcel_keyword_prefix = "/two-wheelers/";

var ga_path_cashback_keyword_prefix = "offers/cashback/";

var ga_title_cashback_keyword_prefix = "Offers Cashback - ";

var ga_path_discount_keyword_prefix = "offers/discount/";

var ga_title_discount_keyword_prefix = "Offers Discount - ";

var ga_header_event_prefix = "Header";

var ga_footer_event_prefix = "Footer";

var ga_api_doc_learn_more_click = "Api Doc Learn More Click";

export {
  ga_title_home ,
  ga_path_home ,
  ga_title_enterprise_faqs ,
  ga_path_enterprise_faqs ,
  ga_title_seo_pillar ,
  ga_path_seo_pillar ,
  ga_title_seo_keyword_prefix ,
  ga_path_seo_keyword_prefix ,
  ga_title_privacy_policy ,
  ga_path_privacy_policy ,
  ga_title_privacy_policy_v1 ,
  ga_path_privacy_policy_v1 ,
  ga_title_privacy_policy_v2 ,
  ga_path_privacy_policy_v2 ,
  ga_title_spot_faq ,
  ga_path_spot_faq ,
  ga_title_porter_wallet_faq ,
  ga_path_porter_wallet_faq ,
  ga_title_insurance_faq ,
  ga_path_insurance_faq ,
  ga_title_tos_partners ,
  ga_path_tos_partners ,
  ga_title_referral_tnc ,
  ga_path_referral_tnc ,
  ga_title_courier_tnc ,
  ga_path_courier_tnc ,
  ga_title_terms_of_service ,
  ga_path_terms_of_service ,
  ga_title_support ,
  ga_path_support ,
  ga_title_about_us ,
  ga_path_about_us ,
  ga_title_enterprise_lp ,
  ga_path_enterprise_lp ,
  ga_title_offers ,
  ga_path_offers ,
  ga_title_careers ,
  ga_path_careers ,
  ga_path_city_page_prefix ,
  ga_title_city_page_prefix ,
  ga_path_trucks_prefix ,
  ga_title_trucks_prefix ,
  ga_title_fare_estimate_result ,
  ga_path_fare_estimate_result ,
  ga_title_partners ,
  ga_path_partners ,
  ga_path_enterprise ,
  ga_title_enterprise ,
  ga_path_api_integrations ,
  ga_title_api_integrations ,
  ga_title_404 ,
  ga_title_bike_parcel_keyword_prefix ,
  ga_path_bike_parcel_keyword_prefix ,
  ga_path_cashback_keyword_prefix ,
  ga_title_cashback_keyword_prefix ,
  ga_path_discount_keyword_prefix ,
  ga_title_discount_keyword_prefix ,
  ga_header_event_prefix ,
  ga_footer_event_prefix ,
  ga_api_doc_learn_more_click ,
}
/* No side effect */
